import { render, staticRenderFns } from "./delStatusInfo.vue?vue&type=template&id=6428610c"
import script from "./delStatusInfo.vue?vue&type=script&lang=js"
export * from "./delStatusInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports